import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';
import { queryKeys } from '@/lib/queryKeys';
import type { NoticePost } from '@/lib/types';

/**
 * 지금 세워야 할 팝업 공지 — <b>기간이 남은 것만</b> 서버가 준다(화면이 날짜를 세지 않는다).
 *
 * <p>읽는 곳이 둘이다: 홈이 무엇을 띄울지 고르고(`NoticePopup`), 새 창이 그중 한 건을 그린다
 * (`NoticePopupWindow`). 새 창은 <b>다른 탭</b>이라 캐시를 나눠 갖지 못하므로 자기 몫을 한 번 더
 * 받아 온다 — 글 한 건짜리 요청이고, 그것 때문에 조회 API 를 하나 더 만들 이유는 없다.
 *
 * <p>홈을 열어 둔 채 며칠이 지나는 사람이 있어 신선도를 길게 두지 않는다.
 */
export function useNoticePopups(): UseQueryResult<NoticePost[]> {
  return useQuery({
    queryKey: queryKeys.noticePopups,
    queryFn: () => apiFetch<NoticePost[]>('/v1/notices/popups'),
    staleTime: 5 * 60 * 1000,
  });
}
